import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import a from "clsx";
import e, { useContext as y, useEffect as g, useState as h } from "react";
import { useEscKeyListener as k } from "../../hooks/useEscKeyListener";
import { useOnClickOutside as v } from "../../hooks/useOnClickOutside";
import { PrimaryNavContext as C } from "./PrimaryNavContext";
import { UserActionsMenu as O } from "./UserActionsMenu";
import { getFirstNameLastInitial as b } from "./helpers/user";

var T = function T() {
  var c, u, m;

  var _y = y(C),
      o = _y.isUserActionsMenuOpen,
      i = _y.setIsUserActionsMenuOpen,
      s = _y.authenticatedUser,
      r = _y.menuData,
      l = _y.loginAction,
      t = (c = r == null ? void 0 : r.userActions) == null ? void 0 : c.find(function (_) {
    return _.name === "log-in";
  }),
      p = function p() {
    i(!0);
  },
      n = function n() {
    i(!1);
  },
      _h = h(null),
      _h2 = _slicedToArray(_h, 2),
      d = _h2[0],
      f = _h2[1];

  return v({
    current: d
  }, n, "on-click-outside"), k(o, n), g(function () {
    s || i(!1);
  }, [s, i]), e.createElement("li", {
    className: a("hg-primarynav__item", "hg-primarynav__item--useractions")
  }, e.createElement("div", {
    className: a("hg-primarynav__desktop-item", "on-click-outside")
  }, s ? e.createElement("button", {
    className: "hg-primarynav__desktop-item-useractions-button",
    id: "useractionstrigger-desktop-button",
    "aria-controls": "hg-primarynav__desktop-useractions-flyout",
    "aria-label": "User Actions Menu",
    type: "button",
    onClick: o ? n : p
  }, b(s)) : e.createElement("a", {
    href: (u = t == null ? void 0 : t.url) != null ? u : "/authenticate/signin",
    className: "hg-primarynav__desktop-item-useractions-anchor",
    onClick: l
  }, (m = t == null ? void 0 : t.label) != null ? m : "Log in"), s && e.createElement("div", {
    ref: f,
    className: a("hg-primarynav__desktop-useractions-flyout", "on-click-outside", {
      "hg-primarynav__desktop-useractions-flyout--is-open": o
    }),
    id: "hg-primarynav__desktop-useractions-flyout"
  }, e.createElement(O, null))));
};

export { T as DesktopUserActionsTrigger };